export default __webpack_public_path__ + "static/media/async-await.3cfc0a4b.png";